import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Star, ShieldCheck, Lock, Apple } from "lucide-react";
import { Reveal } from "../fx/Reveal";

const Mark = ({ children, className = "" }) => <span className={`pay-logo ${className}`}>{children}</span>;

export const PaymentLogos = ({ compact = false }) => (
  <div data-testid="payment-logos" className={`flex flex-wrap items-center ${compact ? "gap-2" : "justify-center gap-3"}`}>
    <Mark><span className="w-5 h-3.5 rounded-sm bg-gradient-to-br from-[#1A1F71] to-[#2A3A9E] inline-block" /> VISA</Mark>
    <Mark><span className="relative inline-block w-6 h-3.5"><span className="absolute left-0 top-0 w-3.5 h-3.5 rounded-full bg-[#EB001B]" /><span className="absolute right-0 top-0 w-3.5 h-3.5 rounded-full bg-[#F79E1B] opacity-90" /></span> Mastercard</Mark>
    <Mark><span className="w-4 h-4 rounded bg-[#003087] text-white text-[10px] font-black italic flex items-center justify-center">P</span> PayPal</Mark>
    <Mark><Apple size={14} className="fill-white" /> Apple Pay</Mark>
    <Mark><span className="text-[13px] font-black text-[#4285F4]">G</span> Google Pay</Mark>
    <Mark className="!text-[#8AA4FF]"><Lock size={12} /> Stripe</Mark>
    <Mark><span className="w-4 h-4 rounded bg-[#0E7C3A] text-white text-[9px] font-black flex items-center justify-center">CB</span> Carte Bancaire</Mark>
  </div>
);

export const TrustBanner = () => {
  const [sum, setSum] = useState(null);
  useEffect(() => { api.get("/reviews/summary").then(({ data }) => setSum(data)).catch(() => {}); }, []);
  const hasReviews = sum?.count > 0;
  return (
  <section data-testid="trust-banner" className="relative mt-20 border-y border-[#1E232D] bg-[#0A0C10] py-10 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(224,31,31,0.12),transparent_60%)] pointer-events-none" />
    <div className="max-w-[1440px] mx-auto px-5 relative">
      <Reveal>
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-5">
            <div className="w-16 h-16 rounded-2xl bg-[#10131A] border border-[#222735] flex items-center justify-center shadow-inner"><ShieldCheck size={30} className="text-emerald-400" /></div>
            <div>
              <div className="flex items-center gap-1 text-[#f5a623]" data-testid="trust-rating">{[...Array(5)].map((_, i) => <Star key={i} size={18} className={hasReviews && i < Math.round(sum.average) ? "fill-[#f5a623]" : "text-slate-600"} />)}{hasReviews && <span className="text-white font-extrabold ml-2 text-lg">{String(sum.average).replace(".", ",")}<span className="text-slate-500 text-sm font-semibold"> / 5</span></span>}</div>
              <div className="text-slate-300 text-[14px] mt-1">{hasReviews ? <><strong className="text-white">{sum.satisfied_pct} % de clients satisfaits</strong> · {sum.count} avis de clients identifiés</> : <><strong className="text-white">Avis de clients identifiés</strong> · chaque note est liée à un compte client, mention « achat vérifié » après commande</>}</div>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 md:gap-8 text-center">
            {[["+ 650 000", "références"], ["24 / 48 h", "livraison express"], ["30 jours", "retours gratuits"]].map(([v, l]) => (
              <div key={l}><div className="font-display font-extrabold italic text-xl md:text-2xl text-white leading-none">{v}</div><div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-1.5">{l}</div></div>
            ))}
          </div>
        </div>
        <div className="mt-8 pt-7 border-t border-[#1E232D]/70 flex flex-col items-center gap-3">
          <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500 font-bold flex items-center gap-2"><Lock size={12} className="text-[#FF3B3B]" /> Paiement 100 % sécurisé</div>
          <PaymentLogos />
        </div>
      </Reveal>
    </div>
  </section>
  );
};

export default TrustBanner;
